import { SVGProps } from 'react'

export const WpsImageSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M14 3a1 1 0 00-1-1H3a1 1 0 00-1 1v7.537l2.82-2.149A1 1 0 015.895 8.3L14 12.602V3zM2 0a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2zm8.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
      fill='#009D69'
      fillRule='evenodd'
    />
  </svg>
)
